import { Injectable } from '@angular/core';
import * as LogRocket from 'logrocket';
import { environment } from '../../../environments/environment';
import { LogRocketUser, LogRocketEventType } from '../models/log-rocket.model';

@Injectable({
  providedIn: 'root'
})
export class LogRocketService {
  private initialized = false;

  constructor() { }

  initialize(): void {
    if (this.initialized) {
      return;
    }

    LogRocket.init(environment.logRocketAppId, {
      console: {
        shouldAggregateConsoleErrors: true,
      },
      network: {
        requestSanitizer: request => {
          if (request.headers['Authorization']) {
            request.headers['Authorization'] = '[REDACTED]';
          }
          return request;
        },
        responseSanitizer: response => {
          return response;
        }
      },
      dom: {
        inputSanitizer: true
      }
    });

    this.initialized = true;
  }

  identifyUser(user: LogRocketUser): void {
    if (!this.initialized) {
      return;
    }

    if (!user || !user.id) {
      return;
    }

    const userProperties: Record<string, any> = {
      name: user.name,
      email: user.email
    };

    if (user.companyName) {
      userProperties.companyName = user.companyName;
    }

    if (user.status) {
      userProperties.status = user.status;
    }

    if (user.privileges && user.privileges.length > 0) {
      userProperties.privileges = user.privileges.join(', ');
    }

    LogRocket.identify(user.id, userProperties);
  }

  trackCustomEvent(eventName: LogRocketEventType | string, properties?: Record<string, any>): void {
    if (!this.initialized) {
      return;
    }

    const eventData = {
      timestamp: new Date().toISOString(),
      ...properties
    };

    LogRocket.track(eventName, eventData);
  }

}
